import client from 'braintree-web/client';
import dataCollector from 'braintree-web/data-collector';
import btPayPal from 'braintree-web/paypal';

let deviceDataInstance: braintree.DataCollector;
let paypalInstance: braintree.PayPal;
let payPalToken: string;

type InitProps = {
  token: string;
};
export const init = async ({ token }: InitProps) => {
  if (token === payPalToken && paypalInstance) {
    return;
  }
  payPalToken = token;

  // Create the braintree client instance
  // Use authToken when API available
  const clientInstance = await client.create({
    authorization: token,
  });

  // Create device data instance for collecting device data
  deviceDataInstance = await dataCollector.create({
    client: clientInstance,
    paypal: true,
    kount: false,
  });

  // Create the paypal instance
  paypalInstance = await btPayPal.create({
    client: clientInstance,
  });
};

export const getInstance = () => paypalInstance;

export const getError = (
  err: braintree.BraintreeError,
): braintree.BraintreeError => {
  if (err.code === 'PAYPAL_POPUP_OPEN_FAILED') {
    return {
      ...err,
      message: 'PaymentProcessingError_paypalPopupErrorMessage',
    };
  }
  return err;
};

export const tokenize = async () =>
  new Promise<{ nonce: string; deviceData: string }>((resolve, reject) => {
    if (!paypalInstance) {
      reject(new Error('missing PayPal client instance'));
      return;
    }
    paypalInstance.tokenize(
      {
        flow: 'vault',
      },
      (err, payload) => {
        err
          ? reject(getError(err))
          : resolve({
              nonce: payload.nonce,
              deviceData: deviceDataInstance.deviceData,
            });
      },
    );
  });
